module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetLow.c6e4f4d.jpg";